<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_9"></a><a id="frontmatter02"></a>THE BALLAD OF THE CHOSEN<br/><span class="smallcaps">(as sung by the soldiers of Winterhome)</span></h2>
<blockquote>
<blockquote>
<p class="para">When day turned dark and shadows fell</p>
<p class="para">Across the broken lands</p>
<p class="para">And madness turned to taloned claws Our ancient ruler’s hands</p>
<p class="para">Then eight were called by whims of fate</p>
<p class="para">To save us from our doom;</p>
<p class="para">The Chosen came to guard us all</p>
<p class="para">And lay evil in its tomb</p>
<p class="para"> </p>
<p class="hangindent-param"><em>[chorus]</em> If a Wizard Lord should turn<br/>Against the common man<br/>These Chosen eight would bring him down,<br/>Bring peace to Barokan!</p>
<p class="para"> </p>
<p class="para">The Leader shows his bold resolve</p>
<p class="para">Confronting every foe</p>
<p class="para">His words would guide the Chosen as</p>
<p class="para">He told them how to go</p>
<p class="para"> </p>
<p class="para">The Seer sought the comrades out</p>
<p class="para">And gathered them to fight</p>
<p class="para">Nor could their foeman hide from her;</p>
<p class="para">She has the second sight</p>
<p class="para"> </p>
<p class="para"><em>[chorus]</em></p>
<p class="para"> </p>
<p class="para">The Swordsman’s blade is swift and sure</p>
<p class="para">His skill is unsurpassed</p>
<p class="para"><a id="page_10"></a>If any stood against him, then</p>
<p class="para">That stand would be his last</p>
<p class="para"> </p>
<p class="para">A lovely face the Beauty has,</p>
<p class="para">And shapely legs and arms</p>
<p class="para">She distracted evil men</p>
<p class="para">And lured them with her charms</p>
<p class="para"> </p>
<p class="para"><em>[chorus]</em></p>
<p class="para"> </p>
<p class="para">There is no lock nor guarded door</p>
<p class="para">That can stop the Thief</p>
<p class="para">He penetrates the fortress dark</p>
<p class="para">To bring the land relief</p>
<p class="para"> </p>
<p class="para">Every song and story told,</p>
<p class="para">The Scholar knows them all</p>
<p class="para">He knew the wizard’s weaknesses</p>
<p class="para">To hasten evil’s fall</p>
<p class="para"> </p>
<p class="para"><em>[chorus]</em></p>
<p class="para"> </p>
<p class="para">The Archer’s missiles never miss;</p>
<p class="para">His arrows find their mark</p>
<p class="para">He struck at evil from afar</p>
<p class="para">To drive away the dark</p>
<p class="para"> </p>
<p class="para">The Speaker harks to every tongue,</p>
<p class="para">Of stone and beast and man</p>
<p class="para">She found the Dark Lord’s secrets out</p>
<p class="para">So no defense could stand</p>
<p class="para"> </p>
<p class="para"><em>[chorus]</em></p>
<p class="para"> </p>
<p class="para">When in the Galbek Hills there was</p>
<p class="para">A monster come in human shape</p>
<p class="para"><a id="page_11"></a>The Swordsman struck the evil down</p>
<p class="para">To save the land from magic rape</p>
<p class="para"> </p>
<p class="para">And thus the last of evil’s spawn</p>
<p class="para">Was driven out of Barokan</p>
<p class="para">Never more will madness come</p>
<p class="para">To trouble Barokan</p>
<p class="para"> </p>
<p class="para">No new Wizard Lord will turn</p>
<p class="para">Against the common man</p>
<p class="para">These Chosen eight shall keep him wise,</p>
<p class="para">Bring peace to Barokan—</p>
<p class="para">Yes, the Chosen guard us all,</p>
<p class="para">Bring peace to Barokan!</p>
</blockquote>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?37c67d42